import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from '@nosto/preact';
import { sortOptions } from '../config';
import Icon from './elements/Icon';
import Select from './elements/Select';

function ToggleMobileSidebarButton({
  lableFor,
  selectedFiltersCount,
  className,
}) {
  return (
    <label
      for={lableFor}
      className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
    >
      <span>Filter</span>
      <span class="gc_filter_icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="icon icon-filter"
        >
          <path d="M18.75 12.75h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5zM12 6a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0112 6zM12 18a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0112 18zM3.75 6.75h1.5a.75.75 0 100-1.5h-1.5a.75.75 0 000 1.5zM5.25 18.75h-1.5a.75.75 0 010-1.5h1.5a.75.75 0 010 1.5zM3 12a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 013 12zM9 3.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM12.75 12a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM9 15.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"></path>
        </svg>
      </span>

      {/* {selectedFiltersCount > 0 && (
        <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
          {selectedFiltersCount}
        </span>
      )} */}
    </label>
  );
}

export default function Toolbar({ lableFor, children }) {
  const { loading, query, response, pageType } = useAppState();
  const { activeSort, setSort } = useSort(sortOptions);
  const selectedFiltersCount = useSelectedFiltersCount();
  const isMobileView = window.innerWidth <= 768;
  const handleSortChange = (event) => {
    setSort(event.target.value);
  };

  const docCount = response.products?.total ?? 0;

  const totalSummaryPhrase =
    pageType === 'category' ? (
      <>{docCount} products</>
    ) : (
      <>
        <b>"{query.query}"</b> matched <span>{docCount}</span> products
      </>
    );

  const options = sortOptions.map((o) => ({
    value: o.id,
    label: o.value.name,
  }));

  return (
    <div
      class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
      style={loading ? 'opacity: 0.3; justify-content: end !important;' : ''}
    >
      {!loading && (
        <span
          class="ns-d-inline  ns-d-md-block  ns-color-black"
          data-nosto-element="totalResults"
        >
          {pageType !== 'category' && (
            <>You searched for {totalSummaryPhrase}</>
          )}
        </span>
      )}
      {children}
      {isMobileView && (
        <div class="nsc-toolbar-wrapper--mobile ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100">
          <ToggleMobileSidebarButton
            lableFor={lableFor}
            selectedFiltersCount={selectedFiltersCount}
            className="nsc-toggle-filter--mobile"
          />
          <Select
            value={activeSort}
            onChange={(e) => handleSortChange(e)}
            className="nsc-toggle-sort--mobile ns-selection-dropdown-sort-menu"
            classNameWrapper={'nsc-toggle-sort-wrapper--mobile'}
            options={options}
          />
        </div>
      )}
    </div>
  );
}
